import { Colors } from 'basic-ui-lib';
import Sidebar from 'layouts/widgets/Sidebar';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useSidebar } from './useSidebar';
import { useMediaQuery } from 'react-responsive';
import BottomNav from 'layouts/widgets/BottomNav';
import Header from 'layouts/widgets/Header';

const SidebarLayout = () => {
  const { open } = useSidebar();
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const hideHeaderAndBottomNavRoutes = ['/screen/create', '/playlist/:id', '/media', 'media/library/detail', 'store/:id', 'screen/:id'];

  const isHideHeaderAndBottomNav = hideHeaderAndBottomNavRoutes.some((route) =>
    matchPath(route, location.pathname)
  );

  if (isMobile) {
    return (
      <>
        {isHideHeaderAndBottomNav ? null : <Header />}
        <WrapperContent>
          <ContentScrollView>
            <Outlet />
          </ContentScrollView>
        </WrapperContent>
        {isHideHeaderAndBottomNav ? null : <BottomNav />}
      </>
    );
  }

  return (
    <>
    <Header />
    <Container>
      {open && <Sidebar />}
      <WrapperContent>
        <ContentScrollView>
          <Outlet />
        </ContentScrollView>
      </WrapperContent>
    </Container>
    </>
  );
};

export default SidebarLayout;

const Container = styled.div`
  display: flex;
  flex: 1;
`;

const WrapperContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${Colors.neutral.bg[2]};
  position: relative;
`;
const ContentScrollView = styled.div`
  position: absolute;
  inset: 0;
  overflow: auto;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
